import {Component} from 'react';

class AccionesComunes extends Component {

    componentDidMount() {
        var Titulo = document.getElementsByClassName("tituloPagina");
        var contenidoTitulo = Titulo[0].outerText;
        document.title = "Ayuda | " + contenidoTitulo;
        window.scrollTo(0, 0);

        // console.log(window.scrollY);
    }

    componentWillUnmount(){
        document.getElementById("conoceSIJE").classList.remove("active");
        document.getElementById("FuncCasilla").classList.remove("active");
        document.getElementById("jornadaElec").classList.remove("active");
        document.getElementById("preguntasFrec").classList.remove("active");

        var colapsarMenu = document.getElementById("menuResponsivo");
        colapsarMenu.classList.replace("show", "not");
    }


    render(){
        return(
            null
            // <div className="menuFloat"></div>
        )
    }
};

export default AccionesComunes;